import { JSX } from 'preact'
import classnames from 'classnames'
import { BlockType, TBlockProps } from '@gsc/types'
import { useTemplateTags } from '../useTemplateTags'
import { useFormContext } from '../Form/useFormContext'
import { useComponentStyle } from '../Style'

export function Input({ inputType, name, placeholder, required, ...props }: TBlockProps<BlockType.Input>): JSX.Element {
  const { template } = useTemplateTags()
  const { getValue, setValue } = useFormContext()
  const { classes } = useComponentStyle('input-text', props)
  const value = getValue(name)
  const className = classnames(classes, { filled: !!value })

  const handleInput = (e: Event) =>
    setValue(name, {
      value: [(e.target as HTMLInputElement).value], // see https://github.com/preactjs/preact/issues/1930
    })

  return (
    <input
      className={className}
      required={required}
      key={name}
      type={inputType}
      name={name}
      value={value}
      onInput={handleInput}
      placeholder={template(placeholder)}
    />
  )
}
